var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78646 11.4536L11.9531 2.07861C12.7819 2.07861 13.5768 2.40785 14.1628 2.9939C14.7489 3.57996 15.0781 4.37481 15.0781 5.20361V9.37028H20.974C21.2759 9.36686 21.5751 9.42914 21.8506 9.5528C22.1261 9.67646 22.3715 9.85855 22.5696 10.0864C22.7678 10.3143 22.9141 10.5826 22.9983 10.8726C23.0825 11.1627 23.1026 11.4675 23.0573 11.7661L21.6198 21.1411C21.5445 21.6379 21.2921 22.0907 20.9093 22.4161C20.5264 22.7415 20.0389 22.9176 19.5365 22.912H7.78646M7.78646 11.4536V22.912M7.78646 11.4536H4.66146C4.10892 11.4536 3.57902 11.6731 3.18832 12.0638C2.79762 12.4545 2.57812 12.9844 2.57812 13.537L2.57813 20.8286C2.57813 21.3812 2.79762 21.9111 3.18832 22.3018C3.57902 22.6925 4.10892 22.912 4.66146 22.912H7.78646",
    stroke: "#189FAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.9ef647e5b8b4dbd0e88bfe95cf84cd59.svg";
export { ForwardRef as ReactComponent };